import React, { useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import AleQuickReplies from './AleQuickReplies';

const List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${(p) => p.theme.colors.background};
`;

const Row = styled.div`
  display: flex;
  justify-content: ${(p) => (p.$user ? 'flex-end' : 'flex-start')};
`;

const Bubble = styled.div`
  max-width: 82%;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 16px; /* legível para idosos */
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;

  background: ${(p) => (p.$user ? p.theme.colors.primary : p.theme.colors.white)};
  color: ${(p) => (p.$user ? p.theme.colors.white : p.theme.colors.textPrimary)};
  border: 1px solid ${(p) => (p.$user ? p.theme.colors.primary : p.theme.colors.border)};
  border-bottom-right-radius: ${(p) => (p.$user ? '4px' : '14px')};
  border-bottom-left-radius: ${(p) => (p.$user ? '14px' : '4px')};
  box-shadow: ${(p) => p.theme.shadows.sm};
`;

const WhatsButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #ecfdf5;
  border: 1px solid #10b981;
  color: #059669;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    background: #d1fae5;
  }
  &:focus-visible {
    outline: 3px solid #10b981;
    outline-offset: 2px;
  }
`;

const blink = keyframes`
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
`;

const Typing = styled.div`
  display: inline-flex;
  gap: 4px;
  padding: 14px 16px;
  background: ${(p) => p.theme.colors.white};
  border: 1px solid ${(p) => p.theme.colors.border};
  border-radius: 14px;

  span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(p) => p.theme.colors.textLight};
    animation: ${blink} 1.2s infinite both;
  }
  span:nth-child(2) { animation-delay: 0.2s; }
  span:nth-child(3) { animation-delay: 0.4s; }

  @media (prefers-reduced-motion: reduce) {
    span { animation: none; opacity: 0.6; }
  }
`;

const AleMessageList = ({ messages, isSending, onQuickReply }) => {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages, isSending]);

  return (
    <List role="log" aria-live="polite" aria-label="Conversa com o Ale">
      {messages.map((m, index) => {
        const isUser = m.role === 'user';
        return (
          <React.Fragment key={m.id}>
            <Row $user={isUser}>
              <Bubble $user={isUser}>
                {m.text}
                {m.whatsappUrl && (
                  <div>
                    <WhatsButton href={m.whatsappUrl} target="_blank" rel="noopener noreferrer">
                      <FaWhatsapp size={18} aria-hidden="true" />
                      Falar no WhatsApp
                    </WhatsButton>
                  </div>
                )}
              </Bubble>
            </Row>

            {/* Perguntas rápidas só no TOPO da conversa (logo após a saudação),
                para rolarem junto com o conteúdo e nunca taparem o que foi digitado. */}
            {index === 0 && onQuickReply && (
              <AleQuickReplies onSelect={onQuickReply} disabled={isSending} />
            )}
          </React.Fragment>
        );
      })}

      {isSending && (
        <Row $user={false}>
          <Typing aria-label="Ale está escrevendo">
            <span />
            <span />
            <span />
          </Typing>
        </Row>
      )}

      <div ref={endRef} />
    </List>
  );
};

export default AleMessageList;
